    <template>
        <div class="container mt-5">
          <AccountInternalTxnsTable v-if="internalList" :address="address" :data="internalList" :page="'showTop'"/>
        </div>
    </template>

    <script>
    import AccountInternalTxnsTable from "@/views/comp_table/account_internal_txs";
    export default {
    name: "index",
      components: {AccountInternalTxnsTable},
      data() {
        return {
          address:'',
          internalList:null,
        }
      },
      methods: {
        //internal txns
        async actionInternal() {
          let v = this
          let result = await v.api('internalTransAddress',{
            page: 1,
            size: 10000,
            address:this.address,
          },{
            vue: v,
            key_data: 'data',
          })

          console.log(result)
          if (result.code=200) {
            this.internalList=result.data.list
          }
        },
      },
      mounted() {
        this.address = this.$route.params.number
        this.actionInternal()
      }
    }
    </script>

    <style scoped>

    </style>
